/* ================================================================
   CL · Cart Toast — California Leaf
   - Convierte las adiciones al carrito en una notificacion compacta.
   - Evita que <cart-drawer> se abra automaticamente tras /cart/add.
   - El icono del carrito conserva la apertura normal del drawer.
   - Detecta PDP, cards, Searchanise y modulos personalizados que usen
     Shopify Ajax Cart API (/cart/add o /cart/add.js).
   ================================================================ */
(function () {
  'use strict';

  if (window.__clCartToastInstalled) return;
  window.__clCartToastInstalled = true;

  var AUTO_CLOSE_MS = 4500;
  var toastTimer = null;
  var lastAddedAt = 0;

  window.CL_CART_TOAST = window.CL_CART_TOAST || {};
  window.CL_CART_TOAST.suppressProgrammaticDrawer = true;

  function isCartAddRequest(input, init) {
    var url = '';
    var method = 'GET';

    try {
      if (typeof Request !== 'undefined' && input instanceof Request) {
        url = input.url || '';
        method = (init && init.method) || input.method || 'GET';
      } else {
        url = String(input || '');
        method = (init && init.method) || 'GET';
      }

      var parsed = new URL(url, window.location.origin);
      return (
        String(method).toUpperCase() === 'POST' &&
        /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname)
      );
    } catch (error) {
      return false;
    }
  }

  function getProductData(payload) {
    if (!payload || payload.status) return null;

    if (Array.isArray(payload.items) && payload.items.length) {
      return {
        item: payload.items[0],
        count: payload.items.length
      };
    }

    return {
      item: payload,
      count: 1
    };
  }

  function getProductName(item, count) {
    if (count > 1) return count + ' productos';
    if (!item) return 'El producto';
    return item.product_title || item.title || item.product_name || 'El producto';
  }

  function getProductUrl(item) {
    if (!item) return '';
    var url = item.url || item.product_url || '';
    if (!url) return '';

    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return url;
    }
  }

  function ensureToast() {
    var toast = document.getElementById('CLCartToast');
    if (toast) return toast;

    toast = document.createElement('aside');
    toast.id = 'CLCartToast';
    toast.className = 'cl-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.setAttribute('aria-hidden', 'true');

    toast.innerHTML =
      '<div class="cl-cart-toast__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5 9.2 17 19 7"/></svg>' +
      '</div>' +
      '<div class="cl-cart-toast__content">' +
        '<div class="cl-cart-toast__eyebrow">Agregado al carrito</div>' +
        '<a class="cl-cart-toast__product" href="#"></a>' +
        '<div class="cl-cart-toast__actions">' +
          '<a class="cl-cart-toast__cart-link" href="/cart">Ver carrito</a>' +
        '</div>' +
      '</div>' +
      '<button class="cl-cart-toast__close" type="button" aria-label="Cerrar notificacion">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>' +
      '</button>';

    document.body.appendChild(toast);

    var close = toast.querySelector('.cl-cart-toast__close');
    if (close) close.addEventListener('click', hideToast);

    toast.addEventListener('mouseenter', function () {
      if (toastTimer) window.clearTimeout(toastTimer);
    });

    toast.addEventListener('mouseleave', scheduleHide);
    toast.addEventListener('focusin', function () {
      if (toastTimer) window.clearTimeout(toastTimer);
    });
    toast.addEventListener('focusout', scheduleHide);

    return toast;
  }

  function scheduleHide() {
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, AUTO_CLOSE_MS);
  }

  function hideToast() {
    var toast = document.getElementById('CLCartToast');
    if (!toast) return;

    if (toastTimer) {
      window.clearTimeout(toastTimer);
      toastTimer = null;
    }

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  }

  function showToast(payload) {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function () {
        showToast(payload);
      }, { once: true });
      return;
    }

    var data = getProductData(payload);
    if (!data || !data.item) return;

    var toast = ensureToast();
    var name = getProductName(data.item, data.count);
    var productUrl = getProductUrl(data.item);
    var productLink = toast.querySelector('.cl-cart-toast__product');
    var cartLink = toast.querySelector('.cl-cart-toast__cart-link');

    if (productLink) {
      productLink.textContent = name + (data.count > 1 ? ' se añadieron al carrito.' : ' se añadió al carrito.');
      if (productUrl && data.count === 1) {
        productLink.href = productUrl;
        productLink.removeAttribute('aria-disabled');
      } else {
        productLink.removeAttribute('href');
        productLink.setAttribute('aria-disabled', 'true');
      }
    }

    if (cartLink) {
      cartLink.href = (window.routes && window.routes.cart_url) || '/cart';
    }

    if (toastTimer) window.clearTimeout(toastTimer);

    toast.setAttribute('aria-hidden', 'false');
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    lastAddedAt = Date.now();
    scheduleHide();

    document.dispatchEvent(new CustomEvent('cl:cart-added', {
      detail: {
        item: data.item,
        count: data.count,
        addedAt: lastAddedAt
      }
    }));
  }

  function installDrawerGuard() {
    if (!window.customElements || !window.customElements.whenDefined) return;

    window.customElements.whenDefined('cart-drawer').then(function () {
      var CartDrawer = window.customElements.get('cart-drawer');
      if (!CartDrawer || !CartDrawer.prototype || CartDrawer.prototype.__clCartToastPatched) return;

      var originalOpen = CartDrawer.prototype.open;
      if (typeof originalOpen !== 'function') return;

      CartDrawer.prototype.open = function (triggeredBy) {
        /*
          El tema abre el drawer sin argumento cuando termina un add-to-cart.
          El click real sobre #cart-icon-bubble si envia el elemento como
          triggeredBy. Asi distinguimos ambos casos sin romper el carrito.
        */
        if (
          window.CL_CART_TOAST &&
          window.CL_CART_TOAST.suppressProgrammaticDrawer &&
          !triggeredBy
        ) {
          return;
        }

        return originalOpen.apply(this, arguments);
      };

      CartDrawer.prototype.__clCartToastPatched = true;
    }).catch(function () {});
  }

  function installFetchObserver() {
    if (!window.fetch || window.fetch.__clCartToastWrapped) return;

    var nativeFetch = window.fetch.bind(window);

    function wrappedFetch(input, init) {
      var shouldObserve = isCartAddRequest(input, init);
      var responsePromise = nativeFetch(input, init);

      if (shouldObserve) {
        responsePromise
          .then(function (response) {
            if (!response || !response.ok) return null;
            return response.clone().json().catch(function () { return null; });
          })
          .then(function (payload) {
            if (payload && !payload.status) showToast(payload);
          })
          .catch(function () {});
      }

      return responsePromise;
    }

    wrappedFetch.__clCartToastWrapped = true;
    wrappedFetch.__clCartToastNative = nativeFetch;
    window.fetch = wrappedFetch;
  }

  installDrawerGuard();
  installFetchObserver();

  window.CL_CART_TOAST.show = showToast;
  window.CL_CART_TOAST.hide = hideToast;
})();
